import { cx } from '@emotion/css';
import { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import TextField from '@mui/material/TextField';

import callAllFn from '@julofinance/web-helpers/dist/fn/callAllFn';
import mergeRefs from '@julofinance/web-helpers/dist/fn/mergeRefs';

import FieldGroup from '../field-group';

import { InputHookFormProps } from './types';
import { inputCx } from './styles';

const InputHookForm = forwardRef<HTMLDivElement, InputHookFormProps>(
  (props, ref) => {
    const {
      formContext,
      name,
      defaultValue,
      required,
      rules,
      helperText,
      value,
      onChange,
      onBlur,
      className,
      inputClassName,
      inputRef = null,
      type,
      InputLabelProps,
      label,
      isInvalid,
      ...resProps
    } = props;

    const { control } = formContext;
    const {
      fieldState: { error, invalid },
      field: {
        ref: controlRef,
        onChange: controllerOnChange,
        onBlur: controllerOnBlur,
        value: controllerValue,
      },
    } = useController({
      name,
      control,
      defaultValue,
      rules: {
        ...(required && { required: 'This field is required' }),
        ...(rules && rules),
      },
    });

    return (
      <FieldGroup
        ref={ref}
        invalid={isInvalid || invalid}
        error={error}
        helperText={helperText}
        className={className}
        name={name}
      >
        <TextField
          {...resProps}
          type={type}
          label={label}
          inputRef={mergeRefs(controlRef, inputRef)}
          className={cx(inputCx, inputClassName)}
          error={isInvalid || invalid}
          variant='standard'
          value={value ?? controllerValue}
          onChange={callAllFn(onChange, controllerOnChange)}
          onBlur={callAllFn(onBlur, controllerOnBlur)}
          InputLabelProps={{
            ...InputLabelProps,
            shrink: true,
          }}
          name={name}
        />
      </FieldGroup>
    );
  },
);

export default InputHookForm;
